exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btnLegend {\n    font-size: 0.6rem;\n}\n", ""]);

// exports
